export function formatMonthYear(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date)) return "";
  return date.toLocaleString("en-US", { month: "short", year: "numeric" });
}

export function euroReadable(value) {
  if (typeof value !== "number" || isNaN(value)) return null;
  const by_000 = value.toLocaleString("en-US", { maximumFractionDigits: 6 });
  let res;
  if (value === 0) {
    res = "-";
  } else if (Math.abs(value) < 100) {
    res = `€ ${value.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  } else if (Math.abs(value) < 100000) {
    res = `€ ${(value / 1000).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}k`;
  } else {
    res = `€ ${(value / 1000000).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}m`;
  }
  return (
    <span data-bs-toggle="tooltip" title={`€ ${by_000}`}>
      {res}
    </span>
  );
}

export function multiple(value) {
  if (typeof value !== "number" || isNaN(value)) return null;
  return `x${value.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function valuationMultiple(stored_portfolio) {
  if (!stored_portfolio) {
    return null;
  }
  const { total_value_in_euro, invested_amount_in_euro } =
    stored_portfolio ?? {};
  if (
    total_value_in_euro === undefined ||
    invested_amount_in_euro === undefined ||
    total_value_in_euro == null ||
    invested_amount_in_euro == null
  ) {
    return null;
  }
  if (invested_amount_in_euro !== 0) {
    return total_value_in_euro / invested_amount_in_euro;
  }
  return null;
}
